import { PerspectiveCamera } from 'three'

export default class BaseCamera {

    constructor(props = {}) {
        this.props = props
        this.isCamera = true
        this.cam = new PerspectiveCamera(55, window.innerWidth / window.innerHeight, 0.1, 100)
        this.base = this.cam
    }


    resize() {
        this.cam.aspect = window.innerWidth / window.innerHeight
        this.cam.updateProjectionMatrix()
    }

}
